/**
 * 다른 skill 의 system prompt 본문에 붙여넣을 `skill_call(...)` 템플릿 문자열.
 * message 는 빈 문자열로 두어 paste 후 사용자가 따옴표 안에 채워넣게 한다.
 */
export function skillCallTemplate(skillId: string): string {
  return `skill_call(skill_id="${skillId}", message="")`;
}
